var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { imgSrc } = options; 
__p+='\n\n<img data-src="'+
((__t=( imgSrc ))==null?'':__t)+
'" class="owl-lazy">\n';
return __p;
};



// WEBPACK FOOTER //
// ./local/templates/community_small_photo_gallery.jst.ejs